<template>
    <div>
        <compFormEdit
            class="margin-top-15 margin-right-15"
            ref="supplierEditForm"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="80"
            :col="1"
        />
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{
                $t("boss.purchase.submit", { defaultValue: "提交" })
            }}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{
                $t("boss.purchase.cancel", { defaultValue: "取消" })
            }}</vButton>
        </div>
    </div>
</template>
<script>
export default {
    props: ["dingval"],
    data() {
        return {
            formData: {
                checkVal: this.dingval || 0,
            },
        };
    },
    computed: {
        getBase() {
            return [
                {
                    tag: "vCheckbox",
                    key: "checkVal",
                    span: 24,
                    label: this.$t("boss.purchase.submit_Ding_Talk", {
                        defaultValue: "同时提交钉钉申请流程",
                    }),
                    labelWidth: 150,
                    required: false,
                    props: {
                        trueValue: 1,
                        falseValue: 0,
                        strict: false,
                    },
                },
            ];
        },
    },
    methods: {
        submit() {
            this.$emit("on-submit", this.formData.checkVal);
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>
